import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { CustomIcon } from 'modules/components/layer00';
import { SaveMetaPhotoForm } from 'modules/components/layer12';

import { useTheme } from '@mui/material';

export type SaveMetaPhotoModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveMetaPhotoModalProps) => {
  const theme = useTheme();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Add Client Report Photos'
      subTitle=''
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={
        <CustomIcon.large.FC icon='RESULT' stroke={theme.palette.primary.main} />
      }
    >
      <SaveMetaPhotoForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
